var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapp"},[_c('div',{staticClass:"top"},[_c('h2',[_vm._v(_vm._s(_vm.$t('home.perimetricLines')))])]),_c('div',{staticClass:"bottom"},[_c('img',{attrs:{"src":_vm.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }